"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fiveMonthFlexHistory = exports.oneMonthFlexHistory = exports.emptyFlexHistory = void 0;
exports.emptyFlexHistory = {
    reporting_events: [],
};
exports.oneMonthFlexHistory = {
    reporting_events: [
        {
            type: 'RENT_PAID',
            text: 'March rent bill paid on time',
            date: '2024-03-10',
        },
        {
            type: 'CREDIT_LINE_USED',
            text: '$0 of credit line used',
            date: '2024-03-29',
        },
    ],
};
exports.fiveMonthFlexHistory = {
    reporting_events: [
        {
            type: 'RENT_PAID',
            text: 'March rent bill paid on time',
            date: '2024-03-10',
        },
        {
            type: 'CREDIT_LINE_USED',
            text: '$0 of credit line used',
            date: '2024-03-29',
        },
        {
            type: 'RENT_PAID',
            text: 'February rent bill on time',
            date: '2024-02-10',
        },
        {
            type: 'CREDIT_LINE_USED',
            text: '$0 of credit line used',
            date: '2024-02-29',
        },
        {
            type: 'RENT_PAID',
            text: 'January rent bill paid on time',
            date: '2024-01-10',
        },
        {
            type: 'CREDIT_LINE_USED',
            text: '$0 of credit line used',
            date: '2024-01-29',
        },
        {
            type: 'RENT_PAID',
            text: 'December rent bill paid on time',
            date: '2023-12-10',
        },
        {
            type: 'CREDIT_LINE_USED',
            text: '$0 of credit line used',
            date: '2023-12-29',
        },
        {
            type: 'RENT_PAID',
            text: 'November rent bill paid on time',
            date: '2023-11-10',
        },
        {
            type: 'CREDIT_LINE_USED',
            text: '$0 of credit line used',
            date: '2023-11-29',
        },
    ],
};
